import PropTypes from 'prop-types'
import TableColumns from 'components/table/tanstack/responsive/TableColumns'
import TableRows from 'components/table/tanstack/responsive/TableRows'
import MediaCompMatch from 'components/MediaCompMatch'
import { TanstackContextProvider } from '../TanstackContext'

export const SORTING_FUNCTIONS = {
  ALPHANUMERIC: 'alphanumeric',
  ALPHANUMERIC_CASE_SENSITIVE: 'alphanumericCaseSensitive',
  TEXT: 'text',
  TEXT_CASE_SENSITIVE: 'textCaseSensitive',
  DATETIME: 'datetime',
  BASIC: 'basic',
}

export const TableResponsive = ({ data, columns, pageSize = 5000 }) => {
  TableResponsive.propTypes = {
    data: PropTypes.array,
    columns: PropTypes.array,
    pageSize: PropTypes.number,
  }

  const mediaQuery = '(max-width: 860px)'

  return (
    <TanstackContextProvider
      data={data}
      columns={columns}
      initialState={{ pagination: { pageSize } }}
    >
      <MediaCompMatch
        query={mediaQuery}
        matchComponent={<TableRows data={data} columns={columns} />}
        noMatchComponent={<TableColumns data={data} columns={columns} />}
      />
    </TanstackContextProvider>
  )
}

export default TableResponsive
